export default __webpack_public_path__ + "static/osaka-4ae2bc96b92e329ce6dde95381c348a8.jpeg";